import type { BareFetcher, SWRConfiguration } from '@ori/fetching';
import type { StaticLocalizationsSingleLanguageLocalizationsDto } from '@ori/static-api-client-react';
import { useGetTenantLocalization } from '@ori/static-api-client-react';

import { APP_NAME } from '../constants';
import { useConfiguration } from '../contexts';

export function useLocalizationQuery(
  config?: SWRConfiguration<
    StaticLocalizationsSingleLanguageLocalizationsDto,
    Error,
    BareFetcher<StaticLocalizationsSingleLanguageLocalizationsDto>
  >,
) {
  const { currentLanguage, tenant } = useConfiguration();

  return useGetTenantLocalization(
    tenant,
    APP_NAME,
    { lang: currentLanguage },
    {
      swr: {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        ...config,
      },
    },
  );
}
